/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './email-address-modal.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/user/email-address-modal/email-address-modal.component';
import * as i3 from '@angular/forms';
import * as i4 from '../../../../app/shared/custom-scrollbar/custom-scrollbar.directive';
import * as i5 from '../../../../app/shared/translations/translate.directive';
import * as i6 from '../../../../app/shared/translations/translations.service';
import * as i7 from '../../../../app/shared/settings.service';
import * as i8 from '../../shared/svg-icon/svg-icon.component.ngfactory';
import * as i9 from '../../../../app/shared/svg-icon/svg-icon.component';
import * as i10 from '@angular/common';
import * as i11 from '../../../../app/admin/users/user.service';
const styles_EmailAddressModalComponent:any[] = [i0.styles];
export const RenderType_EmailAddressModalComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_EmailAddressModalComponent,data:{}});
function View_EmailAddressModalComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'div',[['class',
      'error']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.errors['emails.0'];
    _ck(_v,1,0,currVal_0);
  });
}
export function View_EmailAddressModalComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'div',[['class',
      'backdrop']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n\n'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          47,'form',[['class','modal-content'],['customScrollbar',''],['novalidate',
              '']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngSubmit'],[(null as any),'submit'],[(null as any),'reset']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.EmailAddressModalComponent = _v.component;
            if (('submit' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,4).onSubmit($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,4).onReset()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
              const pd_2:any = ((<any>_co.confirm()) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i3.ɵbf,([] as any[]),
          (null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i3.NgForm,[[8,
          (null as any)],[8,(null as any)]],(null as any),{ngSubmit:'ngSubmit'}),i1.ɵprd(2048,
          (null as any),i3.ControlContainer,(null as any),[i3.NgForm]),i1.ɵdid(16384,
          (null as any),0,i3.NgControlStatusGroup,[i3.ControlContainer],(null as any),
          (null as any)),i1.ɵdid(4341760,(null as any),0,i4.CustomScrollbarDirective,
          [i1.ElementRef],{theme:[0,'theme']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),11,'div',[['class',
          'modal-header']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),2,'h2',[['class','modal-title'],['trans','']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(4341760,(null as any),0,i5.TranslateDirective,[i1.ElementRef,i6.Translations,
          i7.SettingsService],(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['Enter Email Address'])),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),4,'button',[['class','close-button no-style icon-button'],
          ['type','button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.EmailAddressModalComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.close()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'svg-icon',[['name','close']],
          (null as any),(null as any),(null as any),i8.View_SvgIconComponent_0,i8.RenderType_SvgIconComponent)),
      i1.ɵdid(114688,(null as any),0,i9.SvgIconComponent,[i1.ElementRef,i1.Renderer2],
          {name:[0,'name']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵted((null as any),['\n\n    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),15,'div',[['class','input-container']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),0,'label',[['for','email']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),7,'input',[['id','email'],['name',
          'email'],['required',''],['type','email']],[[1,'required',0],[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],
          [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
          [(null as any),'compositionend']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.EmailAddressModalComponent = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,27)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,27).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,27)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,27)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_4:any = ((<any>(_co.emailAddress = $event)) !== false);
          ad = (pd_4 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i3.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i3.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i3.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵprd(1024,(null as any),i3.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i3.RequiredValidator]),i1.ɵprd(1024,(null as any),i3.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i3.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i3.NgModel,[[2,
          i3.ControlContainer],[2,i3.NG_VALIDATORS],[8,(null as any)],[2,i3.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i3.NgControl,(null as any),[i3.NgModel]),i1.ɵdid(16384,(null as any),
          0,i3.NgControlStatus,[i3.NgControl],(null as any),(null as any)),(_l()(),
          i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_EmailAddressModalComponent_1)),i1.ɵdid(16384,
          (null as any),0,i10.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵted((null as any),
          ['\n\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),9,'div',[['class',
          'buttons right']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),2,'button',[['class','button cancel'],['trans',
              ''],['type','button']],(null as any),[[(null as any),'click']],(_v,en,
              $event) => {
            var ad:boolean = true;
            var _co:i2.EmailAddressModalComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.close()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(4341760,(null as any),0,i5.TranslateDirective,
          [i1.ElementRef,i6.Translations,i7.SettingsService],(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['Cancel'])),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),2,'button',[['class','button primary submit-button'],
          ['trans',''],['type','submit']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(4341760,(null as any),0,i5.TranslateDirective,
          [i1.ElementRef,i6.Translations,i7.SettingsService],(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['Confirm'])),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i2.EmailAddressModalComponent = _v.component;
    const currVal_7:any = '';
    _ck(_v,7,0,currVal_7);
    const currVal_8:any = 'close';
    _ck(_v,18,0,currVal_8);
    const currVal_17:any = '';
    _ck(_v,28,0,currVal_17);
    const currVal_18:any = 'email';
    const currVal_19:any = _co.emailAddress;
    _ck(_v,31,0,currVal_18,currVal_19);
    const currVal_20:any = _co.errors['emails.0'];
    _ck(_v,36,0,currVal_20);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,6).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,6).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,6).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,6).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,6).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,6).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,6).ngClassPending;
    _ck(_v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_9:any = (i1.ɵnov(_v,28).required? '': (null as any));
    const currVal_10:any = i1.ɵnov(_v,33).ngClassUntouched;
    const currVal_11:any = i1.ɵnov(_v,33).ngClassTouched;
    const currVal_12:any = i1.ɵnov(_v,33).ngClassPristine;
    const currVal_13:any = i1.ɵnov(_v,33).ngClassDirty;
    const currVal_14:any = i1.ɵnov(_v,33).ngClassValid;
    const currVal_15:any = i1.ɵnov(_v,33).ngClassInvalid;
    const currVal_16:any = i1.ɵnov(_v,33).ngClassPending;
    _ck(_v,26,0,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,
        currVal_16);
  });
}
export function View_EmailAddressModalComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'email-address-modal',
      ([] as any[]),(null as any),(null as any),(null as any),View_EmailAddressModalComponent_0,
      RenderType_EmailAddressModalComponent)),i1.ɵdid(49152,(null as any),0,i2.EmailAddressModalComponent,
      [i1.ElementRef,i1.Renderer2,i11.UserService],(null as any),(null as any))],(null as any),
      (null as any));
}
export const EmailAddressModalComponentNgFactory:i1.ComponentFactory<i2.EmailAddressModalComponent> = i1.ɵccf('email-address-modal',
    i2.EmailAddressModalComponent,View_EmailAddressModalComponent_Host_0,{},{onShow:'onShow',
        onClose:'onClose',onDone:'onDone'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/user/email-address-modal/email-address-modal.component.ngfactory.ts